import { IAdminDocument } from '../../components/admin/supervisors/interfaces';

export enum AdminDocumentActionType {
    CREATE_ADMIN_DOCUMENT = 'CREATE_ADMIN_DOCUMENT',
    UPDATE_ADMIN_DOCUMENT = 'UPDATE_ADMIN_DOCUMENT',
    GET_ALL_ADMIN_DOCUMENTS = 'GET_ALL_ADMIN_DOCUMENTS',
    GET_ADMIN_DOCUMENTS_BY_ROLE = 'GET_ADMIN_DOCUMENTS_BY_ROLE',
    DELETE_ADMIN_DOCUMENT = 'DELETE_ADMIN_DOCUMENT',
    GET_LAYER_ADMIN_DOCUMENTS = 'GET_LAYER_ADMIN_DOCUMENTS',
}

interface GetAdminDocumentsAction {
    type: AdminDocumentActionType.GET_ALL_ADMIN_DOCUMENTS;
    payload: Array<IAdminDocument>;
}

interface GetAdminDocumentsByRoleAction {
    type: AdminDocumentActionType.GET_ADMIN_DOCUMENTS_BY_ROLE;
    payload: Array<IAdminDocument>;
}

interface GetLayerAdminDocumentsAction {
    type: AdminDocumentActionType.GET_LAYER_ADMIN_DOCUMENTS;
    payload: Array<IAdminDocument>;
}

interface CreateAdminDocumentAction {
    type: AdminDocumentActionType.CREATE_ADMIN_DOCUMENT;
    payload: IAdminDocument;
}

interface UpdateAdminDocumentAction {
    type: AdminDocumentActionType.UPDATE_ADMIN_DOCUMENT;
    payload: IAdminDocument;
}

interface DeleteAdminDocumentAction {
    type: AdminDocumentActionType.DELETE_ADMIN_DOCUMENT;
    payload: IAdminDocument;
}

export type AdminDocumentAction =
    | GetAdminDocumentsAction
    | GetAdminDocumentsByRoleAction
    | CreateAdminDocumentAction
    | UpdateAdminDocumentAction
    | DeleteAdminDocumentAction
    | GetLayerAdminDocumentsAction;
